import React from "react";
import { Outlet } from "react-router-dom";

const PrivateRoutes = () => {
  return <Outlet />
};

export default PrivateRoutes;
